var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "documents", attrs: { id: "documents-page-wrapper" } },
    [
      _vm.isUserAllowedToDocumentsAndMedicalAnalyses
        ? _c("c-switcher", {
            staticClass: "finance__switcher h-switcher",
            attrs: {
              type: "group",
              items: [
                { label: "Общие документы", value: "acting_documents" },
                { label: "Мед.книжка", value: "medical_documents" },
              ],
            },
            model: {
              value: _vm.switcherLocal,
              callback: function ($$v) {
                _vm.switcherLocal = $$v
              },
              expression: "switcherLocal",
            },
          })
        : _vm._e(),
      _vm.mainDocumentsSelected ? _c("main-documents") : _vm._e(),
      _vm.medicalDocumentsSelected ? _c("medical-documents") : _vm._e(),
      _c("to-top-button", { attrs: { element: ".layout" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }